import { ControlledMaskInput } from '@sravni/cosago-react-library/lib/components';
import { useFormContext } from '@sravni/cosago-react-library/lib/hooks';
import type { IFieldFactoryProps } from '@sravni/cosago-react-library/lib/types';
import { removeSpaces } from '@sravni/cosago-react-library/lib/utils';

import { Masks } from 'constants/masks';

import type { TPassportFormFields } from 'entities/creditForm';

export const Snils: FC<IFieldFactoryProps> = ({ type, ...props }) => {
  const { trigger } = useFormContext<TPassportFormFields>();

  const handleBlur = () => {
    trigger(type as keyof TPassportFormFields);
  };

  return (
    <div onBlur={handleBlur}>
      <ControlledMaskInput
        {...props}
        name={type}
        mask={Masks.SNILS}
        transformOutput={removeSpaces}
        inputMode="numeric"
        required={false}
      />
    </div>
  );
};
